{
  "filters": "Filters",
  "columns": "Columns",
  "chart": "Chart",
  "addFilter": "Add Filter",
  "addColumn": "Add Column",
  "field": "Field",
  "comparison": "Comparison",
  "value": "Value",
  "link": "Link",
  "savedReport": "Successfully Saved Report",
  "downloadCsv": "Download as CSV",
  "dailyStats": "Daily Stats",
  "subTradeRequest": "Sub-trade Request",
  "client": "Client",
  "account": "Account",
  "subAccount": "Sub-account",
  "transfer": "Transfer",
  "transaction": "Ledger",
  "trade": "Trade",
  "clientGroup": "ClientGroup",
  "goal": "Goal",
  "day": "Day",
  "week": "Week",
  "month": "Month",
  "year": "Year",
  "newReport": "New Report",
  "editReport": "Edit Report",
  "download": "Download",
  "accessTypes": {
    "ORGANIZATIONAL": "Organizational",
    "PUBLIC": "Public",
    "PRIVATE": "Private"
  },
  "saveAs": {
    "modalButton": "Save As",
    "title": "Save As New Report",
    "name": "Name",
    "accessType": "Access Type",
    "button": "Save As"
  },
  "table": {
    "name": "Name",
    "type": "Type",
    "accessType": "Access Type",
    "author": "Author",
    "organization": "Organization"
  },
  "column": {
    "id": "ID",
    "targetAmountCents": "Target Amount Cents",
    "organizationName": "Organization",
    "userId": "User ID",
    "householdId": "Household ID",
    "primaryUserId": "Primary User ID",
    "type": "Type",
    "source": "Source",
    "name": "Name",
    "subAccountType": "Sub-account Type",
    "subAccountSource": "Sub-account Source",
    "subAccountName": "Sub-account Name",
    "amount": "Amount",
    "amountCents": "Amount (cents)",
    "failReason": "Fail Reason",
    "withdrawalReason": "Withdrawal Reason",
    "withdrawalReasonDescription": "Withdrawal Reason Description",
    "adjustmentReason": "Adjustment Reason",
    "isWithdrawAll": "Is Withdraw All",
    "isAdjustment": "Is Adjustment",
    "instantInvest": "Instant Invest",
    "description": "Description",
    "financialProductName": "Financial Product Name",
    "financialProductId": "Financial Product ID",
    "financialProductTicker": "Financial Product Ticker",
    "accountId": "Account ID",
    "accountType": "Account Type",
    "accountState": "Account State",
    "accountCustodianAccountNumber": "Account Custodian Number",
    "accountRepCode": "Account Rep Code",
    "accountRepCodes": "Account Rep Codes",
    "accountCreatedAt": "Account Created At",
    "accountUpdatedAt": "Account Updated At",
    "signedAllFormsAt": "Signed All Forms At",
    "approvedAt": "Approved At",
    "subAccountSignedAllFormsAt": "Sub-account Signed All Forms At",
    "subAccountApprovedAt": "Sub-account Approved At",
    "subAccountCreatedAt": "Sub-account Created At",
    "subAccountUpdatedAt": "Sub-account Updated At",
    "reconciledAt": "Reconciled At",
    "effectiveDate": "Effective Date",
    "subAccountId": "Sub-account ID",
    "subAccountState": "Sub-account State",
    "subAccountFinancialProductId": "Sub-account Model Portfolio ID",
    "subAccountCompletedAt": "Sub-account Completed At",
    "userLink": "Client Link",
    "householdLink": "Household Link",
    "primaryUserLink": "PrimaryUser Link",
    "search": "Search",
    "accountTypes": "Account Types",
    "firstName": "First Name",
    "middleName": "Middle Name",
    "lastName": "Last Name",
    "state": "State",
    "primaryEmail": "Email",
    "phone": "Phone",
    "streetAddress": "Street Address",
    "province": "Province",
    "city": "City",
    "dateOfBirth": "Date Of Birth",
    "foreignTaxCountry": "Foreign Tax Country",
    "citizenships": "Citizenships",
    "companyType": "Company Type",
    "jobTitle": "Job Title",
    "studentAreaOfStudy": "Area Of Study",
    "investmentKnowledge": "Investment Knowledge",
    "employmentStatus": "Employment Status",
    "complianceState": "Compliance State",
    "complianceIssueSource": "Compliance Issue Source",
    "iDCheckCompleted": "ID Check Completed",
    "lastSuitabilityReviewAt": "Last Suitablility Review At",
    "suitabilityScore": "Suitability Score",
    "language": "Language",
    "timezone": "Timezone",
    "maritalStatus": "Marital Status",
    "riskQuestion1": "First Risk Question",
    "riskQuestion2": "Second Risk Question",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "completedAt": "Completed At",
    "marketValueCents": "Market Value",
    "annualIncomeCents": "Annual Income (cents)",
    "financialFixedAssetsCents": "Fixed Assets (cents)",
    "financialLiquidAssetsCents": "Liquid Assets (cents)",
    "totalDebtCents": "Total Debt (cents)",
    "totalNetWorthCents": "Total Net Worth (cents)",
    "moneyAvailableCents": "Cash Available (cents)",
    "netContributionCents": "Net Contributions (cents)",
    "newContributionCents": "New Contributions (cents)",
    "pendingContributionCents": "Pending Contributions (cents)",
    "cashOnHoldToTradeCents": "Cash On Hold To Trade (cents)",
    "cashOnHoldToWithdrawCents": "Cash On Hold To Withdraw (cents)",
    "marketValue": "Market Value",
    "annualIncome": "Annual Income",
    "financialFixedAssets": "Fixed Assets",
    "financialLiquidAssets": "Liquid Assets",
    "totalDebt": "Total Debt",
    "totalNetWorth": "Total Net Worth",
    "moneyAvailable": "Cash Available",
    "netContribution": "Net Contributions",
    "pendingContribution": "Pending Contributions",
    "cashOnHoldToTrade": "Cash On Hold To Trade",
    "cashOnHoldToWithdraw": "Cash On Hold To Withdraw",
    "newContribution": "New Contributions",
    "custodianAccountNumber": "Custodian Account #",
    "primaryUserFirstName": "Primary User First Name",
    "primaryUserMiddleName": "Primary User Middle Name",
    "primaryUserLastName": "Primary User Last Name",
    "primaryUserState": "Primary User State",
    "primaryUserPrimaryEmail": "Primary User Email",
    "primaryUserPhone": "Primary User Phone",
    "primaryUserStreetAddress": "Primary User Street Address",
    "primaryUserProvince": "Primary User Province",
    "primaryUserCity": "Primary User City",
    "primaryUserDateOfBirth": "Primary User Date Of Birth",
    "primaryUserCompanyType": "Primary User Company Type",
    "primaryUserJobTitle": "Primary User Job Title",
    "primaryUserStudentAreaOfStudy": "Primary User Area Of Study",
    "primaryUserInvestmentKnowledge": "Primary User Investment Knowledge",
    "primaryUserEmploymentStatus": "Primary User Employment Status",
    "primaryUserComplianceState": "Primary User Compliance State",
    "primaryUserSuitabilityScore": "Primary User Suitability Score",
    "primaryUserLanguage": "Primary User Language",
    "primaryUserTimezone": "Primary User Timezone",
    "primaryUserMaritalStatus": "Primary User Marital Status",
    "primaryUserRiskQuestion1": "Primary User First Risk Question",
    "primaryUserRiskQuestion2": "Primary User Second Risk Question",
    "primaryUserComplianceIssueSource": "Primary User Compliance Issue Source",
    "primaryUserIDCheckCompleted": "Primary User ID Check Completed",
    "primaryUserLastSuitabilityReviewAt": "Primary User Last Suitablility Review At",
    "primaryUserCreatedAt": "Primary User Created At",
    "primaryUserUpdatedAt": "Primary User Updated At",
    "primaryUserCompletedAt": "Primary User Completed At",
    "primaryUserMarketValueCents": "Primary User Market Value (cents)",
    "primaryUserAnnualIncomeCents": "Primary User Annual Income (cents)",
    "primaryUserFinancialFixedAssetsCents": "Primary User Fixed Assets (cents)",
    "primaryUserFinancialLiquidAssetsCents": "Primary User Liquid Assets (cents)",
    "primaryUserTotalDebtCents": "Primary User Total Debt (cents)",
    "primaryUserTotalNetWorthCents": "Primary User Total Net Worth (cents)",
    "primaryUserMoneyAvailableCents": "Primary User Cash Available (cents)",
    "primaryUserNetContributionCents": "Primary User Net Contributions (cents)",
    "primaryUserNewContributionCents": "Primary User New Contributions (cents)",
    "primaryUserPendingContributionCents": "Primary User Pending Contributions (cents)",
    "primaryUserCashOnHoldToTradeCents": "Primary User Cash On Hold To Trade (cents)",
    "primaryUserCashOnHoldToWithdrawCents": "Primary User Cash On Hold To Withdraw (cents)",
    "primaryUserMarketValue": "Primary User Market Value",
    "primaryUserAnnualIncome": "Primary User Annual Income",
    "primaryUserFinancialFixedAssets": "Primary User FixedAssets",
    "primaryUserFinancialLiquidAssets": "Primary User Liquid Assets",
    "primaryUserTotalDebt": "Primary User Total Debt",
    "primaryUserTotalNetWorth": "Primary User Total Net Worth",
    "primaryUserMoneyAvailable": "Primary User Cash Available",
    "primaryUserNetContribution": "Primary User Net Contributions",
    "primaryUserPendingContribution": "Primary User Pending Contributions",
    "primaryUserCashOnHoldToTrade": "Primary User Cash On Hold To Trade",
    "primaryUserCashOnHoldToWithdraw": "Primary User Cash On Hold To Withdraw",
    "primaryUserNewContribution": "Primary User New Contributions",
    "primaryUserEntityName": "Primary User Entity Name",
    "userFirstName": "Client First Name",
    "userMiddleName": "Client Middle Name",
    "userLastName": "Client Last Name",
    "userState": "Client State",
    "userPrimaryEmail": "Client Email",
    "userPhone": "Client Phone",
    "userStreetAddress": "Client Street Address",
    "userProvince": "Client Province",
    "userCity": "Client City",
    "userDateOfBirth": "Client Date Of Birth",
    "userCompanyType": "Client Company Type",
    "userJobTitle": "Client Job Title",
    "userStudentAreaOfStudy": "Client Area Of Study",
    "userInvestmentKnowledge": "Client Investment Knowledge",
    "userEmploymentStatus": "Client Employment Status",
    "userComplianceState": "Client Compliance State",
    "userSuitabilityScore": "Client Suitability Score",
    "userLanguage": "Client Language",
    "userTimezone": "Client Timezone",
    "userMaritalStatus": "Client Marital Status",
    "userRiskQuestion1": "Client First Risk Question",
    "userRiskQuestion2": "Client Second Risk Question",
    "userComplianceIssueSource": "Client Compliance Issue Source",
    "userPoliticallyExposedDomesticPerson": "Client Politically Exposed Domestic Person",
    "userPoliticallyExposedForeignPerson": "Client Politically Exposed Foreign Person",
    "userHeadOfInternationalOrganization": "Client Head Of International Organization",
    "userIDCheckCompleted": "Client ID Check Completed",
    "userLastSuitabilityReviewAt": "Client Last Suitablility Review At",
    "userCreatedAt": "Client Created At",
    "userUpdatedAt": "Client Updated At",
    "userCompletedAt": "Client Completed At",
    "userMarketValueCents": "Client Market Value (cents)",
    "userAnnualIncomeCents": "Client Annual Income (cents)",
    "userFinancialFixedAssetsCents": "Client Fixed Assets (cents)",
    "userFinancialLiquidAssetsCents": "Client Liquid Assets (cents)",
    "userTotalDebtCents": "Client Total Debt (cents)",
    "userTotalNetWorthCents": "Client Total Net Worth (cents)",
    "userMoneyAvailableCents": "Client Cash Available (cents)",
    "userNetContributionCents": "Client Net Contributions (cents)",
    "userNewContributionCents": "Client New Contributions (cents)",
    "userPendingContributionCents": "Client Pending Contributions (cents)",
    "userCashOnHoldToTradeCents": "Client Cash On Hold To Trade (cents)",
    "userCashOnHoldToWithdrawCents": "Client Cash On Hold To Withdraw (cents)",
    "userMarketValue": "Client Market Value",
    "userAnnualIncome": "Client Annual Income",
    "userFinancialFixedAssets": "Client FixedAssets",
    "userFinancialLiquidAssets": "Client Liquid Assets",
    "userTotalDebt": "Client Total Debt",
    "userTotalNetWorth": "Client Total Net Worth",
    "userMoneyAvailable": "Client Cash Available",
    "userNetContribution": "Client Net Contributions",
    "userPendingContribution": "Client Pending Contributions",
    "userCashOnHoldToTrade": "Client Cash On Hold To Trade",
    "userCashOnHoldToWithdraw": "Client Cash On Hold To Withdraw",
    "userNewContribution": "Client New Contributions",
    "userEntityName": "Client Entity Name",
    "accountMarketValueCents": "Account Market Value (cents)",
    "accountMoneyAvailableCents": "Account Cash Available (cents)",
    "accountNetContributionCents": "Account Net Contributions (cents)",
    "accountNewContributionCents": "Account New Contributions (cents)",
    "accountPendingContributionCents": "Account Pending Contributions (cents)",
    "accountCashOnHoldToTradeCents": "Account Cash On Hold To Trade (cents)",
    "accountCashOnHoldToWithdrawCents": "Account Cash On Hold To Withdraw (cents)",
    "accountMarketValue": "Account Market Value",
    "accountMoneyAvailable": "Account Cash Available",
    "accountNetContribution": "Account Net Contributions",
    "accountPendingContribution": "Account Pending Contributions",
    "accountCashOnHoldToTrade": "Account Cash On Hold To Trade",
    "accountCashOnHoldToWithdraw": "Account Cash On Hold To Withdraw",
    "accountNewContribution": "Account New Contributions",
    "subAccountMoneyAvailableCents": "Sub-account Cash Available (cents)",
    "subAccountNetContributionCents": "Sub-account Net Contributions (cents)",
    "subAccountNewContributionCents": "Sub-account New Contributions (cents)",
    "subAccountPendingContributionCents": "Sub-account Pending Contributions (cents)",
    "subAccountCashOnHoldToTradeCents": "Sub-account Cash On Hold To Trade (cents)",
    "subAccountCashOnHoldToWithdrawCents": "Sub-account Cash On Hold To Withdraw (cents)",
    "subAccountMarketValue": "Sub-account Market Value",
    "subAccountMoneyAvailable": "Sub-account Cash Available",
    "subAccountNetContribution": "Sub-account Net Contributions",
    "subAccountPendingContribution": "Sub-account Pending Contributions",
    "subAccountCashOnHoldToTrade": "Sub-account Cash On Hold To Trade",
    "subAccountCashOnHoldToWithdraw": "Sub-account Cash On Hold To Withdraw",
    "subAccountNewContribution": "Sub-account New Contributions",
    "organization": "Organization",
    "deactivatedAt": "Deactivated At",
    "frozenAt": "Frozen At",
    "reviewingAt": "Reviewing At",
    "readyAt": "Ready At",
    "requestedAt": "Requested At",
    "processingAt": "Processing At",
    "failedAt": "Failed At",
    "canceledAt": "Canceled At",
    "activatedAt": "Activated At",
    "allSigned": "All Documents Signed",
    "isOfficerOfPublicCompany": "Is Officer Of Public Company",
    "isOwnerOfPublicCompany": "Is Owner Of Public Company",
    "isMemberOfIiroc": "Is Member Of Iiroc",
    "politicallyExposedForeignPerson": "Politically Exposed Foreign Person",
    "politicallyExposedDomesticPerson": "Politically Exposed Domestic Person",
    "closeAssociateOfPEP": "Close Associate Of PEP",
    "powerOfAttorneyGranted": "Power Of Attorney Granted",
    "headOfInternationalOrganization": "Head Of International Organization",
    "isSuspicious": "Is Suspicious",
    "suspiciousRules": "Suspicious Rules",
    "suspiciousState": "Suspicious State",
    "settleDate": "Settle Date",
    "date": "Date",
    "quantity": "Quantity",
    "subAccountFinancialProductName": "Sub-Account Model Portfolio Name",
    "valueCents": "Value Cents",
    "goalId": "Goal ID",
    "goalName": "Goal Name",
    "goalType": "Goal Type",
    "goalTimeHorizon": "Goal Time Horizon",
    "goalTargetAmountCents": "Goal Target Amount Cents",
    "feeTierId": "Fee Tier ID",
    "feeTierName": "Fee Tier Name",
    "feeTierState": "Fee Tier State",
    "clientGroupId": "ClientGroup ID",
    "clientGroupName": "ClientGroup Name",
    "clientGroupType": "ClientGroup Type",
    "clientGroupState": "ClientGroup State",
    "clientGroupPrimaryUserId": "ClientGroup PrimaryUser ID",
    "clientGroupFeeTierId": "ClientGroup Fee Tier ID",
    "clientGroupFeeTierState": "ClientGroup Fee Tier State",
    "clientGroupFeeTierName": "ClientGroup Fee Tier Name",
    "affiliateOnly": "Affiliate Only",
    "currency": "Currency",
    "moneyAllocatedCents": "Money Allocated",
    "expectedTradePriceCents": "Expected Trade Price",
    "actualQuantity": "Actual Quantity",
    "expectedQuantity": "Expected Quantity",
    "actualTradePriceCents": "Actual Trade Price",
    "percentageFilled": "Percentage Filled",
    "timeHorizon": "Time Horizon",
    "tradeSecurity": "Trade Security",
    "moneyAllocated": "Money Allocated",
    "expectedTradePrice": "Expected Trade Price",
    "actualTradePrice": "Actual Trade Price",
    "uniqueCircumstances": "Unique Circumstances",
    "sourceOfWealth": "Source of Wealth",
    "sourceOfWealthOtherDescription": "Source of Wealth Description",
    "sourceOfFunds": "Source of Funds",
    "sourceOfFundsOtherDescription": "Source of Funds Description",
    "preferredMethodOfCommunication": "Preferred Method of Communication:",
    "preferredMethodOfCommunicationOtherDescription": "Preferred Method of Communication Description",
    "employerName": "Employer Name",
    "payTaxesOutsideCanada": "Pay Taxes Outside of Canada",
    "trustedContactPersonName": "Trusted Contact Name",
    "trustedContactPersonEmail": "Trusted Contact Email",
    "trustedContactPersonPhone": "Trusted Contact Phone",
    "trustedContactPersonCity": "Trusted Contact City",
    "trustedContactPersonProvince": "Trusted Contact Province",
    "trustedContactPersonRelation": "Trusted Contact Relation",
    "spouseFirstName": "Spouse First Name",
    "spouseLastName": "Spouse Last Name",
    "spouseEmail": "Spouse Email",
    "spouseEmploymentType": "Spouse Employment Type",
    "spouseCompanyType": "Spouse Company Type",
    "spouseJobTitle": "Spouse Occupation",
    "spouseDateOfBirth": "Spouse Date of Birth",
    "spouseAddressProvince": "Spouse Province",
    "spouseAddressCity": "Spouse City",
    "employerCompanyAddress": "Employer Company Address",
    "numberOfClients": "# of Clients",
    "numberOfFundedClients": "# of Funded Clients",
    "calculatedAt": "Calculated At",
    "isAccreditedInvestor": "Is Accredited Investor",
    "isVulnerablePerson": "Is Vulnerable Person",
    "iDVerified": "ID Verified",
    "entityName": "Entity Name",
    "exchange": "Exchange",
    "ticker": "Ticker",
    "scheduleNextDate": "Schedule Next Date",
    "actualTradePriceInCurrencyCents": "Actual Trade Price In Currency Cents",
    "preSplitMaxQuantity": "Pre-split Max Quantity",
    "blockedUntil": "Blocked Until",
    "blockedUntilSubAccountActive": "Blocked Until Sub-account Active",
    "blockedUntilAccountActive": "Blocked Until Account Active",
    "blockedUntilPairActualTradePriceCents": "Block Until Pair Actual Trade Price Cents",
    "maxQuantity": "Max Quantity",
    "publishedAt": "PublishedAt",
    "isSuggestedByOptimizer": "Is Suggested By Optimizer",
    "verificationRequired": "Verification Required",
    "isPartial": "Is Partial",
    "isSellAll": "Is Sell All",
    "originalCurrency": "Original Currency",
    "preSplitMoneyAllocated": "Pre-split Money Allocated",
    "settlementDays": "Settlement Days",
    "settlementDate": "Settlement Date",
    "volatile": "Volatile",
    "verifiedByUser": "Verified By User",
    "verifiedAt": "Verified At",
    "initiatedAt": "Initiated At",
    "accountBaseCurrency": "Account Base Currency",
    "organizationBaseCurrency": "Organization Base Currency",
    "moneyAvailableInOrgCurrency": "Cash Available In Organization Currency",
    "netContributionInOrgCurrency": "Net Contributions In Organization Currency",
    "newContributionInOrgCurrency": "New Contributions In Organization Currency",
    "pendingContributionInOrgCurrency": "Pending Contributions In Organization Currency",
    "cashOnHoldToTradeInOrgCurrency": "Cash On Hold To Trade In Organization Currency",
    "cashOnHoldToWithdrawInOrgCurrency": "Cash On Hold To Withdraw In Organization Currency",
    "marketValueInOrgCurrency": "Market Value In Organization Currency",
    "moneyAvailableCentsInOrgCurrency": "Cash Available In Organization Currency (cents)",
    "netContributionCentsInOrgCurrency": "Net Contributions In Organization Currency (cents)",
    "newContributionCentsInOrgCurrency": "New Contributions In Organization Currency (cents)",
    "pendingContributionCentsInOrgCurrency": "Pending Contributions In Organization Currency (cents)",
    "cashOnHoldToTradeCentsInOrgCurrency": "Cash On Hold To Trade In Organization Currency (cents)",
    "cashOnHoldToWithdrawCentsInOrgCurrency": "Cash On Hold To Withdraw In Organization Currency (cents)",
    "marketValueCentsInOrgCurrency": "Market Value In Organization Currency (cents)",
    "fraudRisk": "Fraud Risk",
    "tradingProcess": "Trading Process",
    "fatcaStatus": "FATCA Status",
    "userAccountGroupId": "User Account Group ID",
    "householdAccountGroupId": "Household Account Group ID",
    "organizationAccountGroupId": "Organization Account Group ID",
    "repCode": "Rep Code"
  },
  "chartType": "Chart Type",
  "groupOn": "Group On",
  "title": "Title",
  "valueAggregation": "Aggregation",
  "formatTitle": "Format",
  "valueFieldTitle": "Value Field",
  "groupingType": "Grouping Type",
  "interval": "Interval",
  "reportType": "Report Type",
  "addWidget": "Add Widget",
  "widgetError": "Unable to display this widget",
  "widgetOptionsError": "Unable to load report options. Close and try again.",
  "successSaveDashboard": "Dashboard saved successfully",
  "successRenameDashboard": "Dashboard renamed successfully",
  "inheritedDashboardReadOnly": "This dashboard belongs to a parent organization. Layout and widgets cannot be saved from this organization.",
  "unsavedTitle": "Discard unsaved changes?",
  "unsavedBody": "You have unsaved changes on this dashboard. If you leave now, those changes will be lost.",
  "discardChanges": "Discard",
  "untitledDashboard": "Dashboard",
  "renameModal": {
    "title": "Rename Dashboard",
    "name": "Name"
  },
  "a11y": {
    "moreActions": "More actions"
  },
  "dashboardMenu": {
    "rename": "Rename",
    "copyFrom": "Copy from another dashboard"
  },
  "addWidgetPlaceholder": {
    "title": "Add Widget"
  },
  "globalFilters": {
    "label": "Global filters",
    "addRule": "Add global rule",
    "clearRules": "Clear active rules ({{count}})",
    "ruleChip": "{{type}} {{field}} {{comparison}} {{value}}",
    "editTitle": "Edit global filters",
    "appliesToWidgets": "Applies to {{count}} widgets of this type",
    "appliesToNoWidgets": "No widgets of this type on this dashboard",
    "widgetBadge": "Filtered",
    "appliedToWidget": "{{count}} global filters applied"
  },
  "addModal": {
    "title": "New Dashboard",
    "name": "Name",
    "organization": "Organization"
  },
  "copyFrom": {
    "title": "Copy from another dashboard",
    "source": "Dashboard to copy",
    "noSources": "There are no other dashboards to copy from.",
    "truncated": "Showing the first {{shown}} dashboards.",
    "summary": "Copies {{widgetCount}} widgets ({{reportTypes}}) and any global filters.",
    "emptySource": "That dashboard has no widgets to copy.",
    "replaceWarning": "This replaces the {{widgetCount}} widgets and {{filterCount}} global filters already on this dashboard.",
    "unsavedHint": "Nothing is saved until you save the dashboard.",
    "confirm": "Replace widgets",
    "success": "Widgets copied. Save the dashboard to keep them."
  },
  "chartTypes": {
    "BAR": "Bar Chart",
    "LINE": "Line Chart",
    "NUMBER": "Number Value",
    "PIE": "Pie Chart"
  },
  "aggregationTypes": {
    "AVG": "Average",
    "SUM": "Sum",
    "VALUE_COUNT": "Count"
  },
  "valueField": {
    "id": "ID",
    "marketValueCents": "Market Value",
    "amountCents": "Amount",
    "valueCents": "Value"
  },
  "format": {
    "CENTS": "Dollar",
    "FLOAT": "Number"
  },
  "groupingTypes": {
    "DATE": "Date",
    "FIRST_DATE_IN_INTERVAL": "First in Interval",
    "GROUPING": "Group",
    "SINGLE_VALUE": "Single Value"
  },
  "intervals": {
    "DAY": "Day",
    "MONTH": "Month",
    "WEEK": "Week",
    "YEAR": "Year"
  },
  "reportTypes": {
    "ACCOUNT": "Account",
    "DAILY_STATS": "Daily Stats",
    "HISTORY": "History",
    "SUB_ACCOUNT": "Sub Accounts",
    "TRANSFER": "Transfers",
    "USER": "User",
    "TRANSACTION": "Transaction",
    "GOAL": "Goal",
    "CLIENT_GROUP": "Households",
    "TRADE": "Trade",
    "SUB_TRADE_REQUEST": "Sub Trade Request"
  },
  "comparisons": {
    "TEXT_SEARCH": "search",
    "EQUALS": "equals",
    "NOT_EQUALS": "not equals",
    "INCLUDES": "includes",
    "NOT_INCLUDES": "does not include",
    "GREATER_THAN": "greater than",
    "LESS_THAN": "less than",
    "GREATER_THAN_AGO": "more than ago",
    "LESS_THAN_AGO": "less than ago",
    "IN": "in",
    "NOT_TEXT_SEARCH": "does not search"
  }
}
